import React, { Component } from "react";
import { Button, Form, Icon, Input, Col, Row, Tooltip, Upload, Popconfirm, Tag } from "antd";
import { message } from "antd/lib/index";
import { getData, createDataUnAuth } from '../../util/API';

const FormItem = Form.Item;

class CombinedForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      location: "",
      pin_code: null,
      city_name: "",
      district: "",
      state_name: "",
      country_name: "",
      address_file_name: "",
      digipin: "",
      fileList: [],
      partner_images_info: [],
      loader: false, // For loading state on submit
      vendor_id: "",
    };
  }

  // Placeholder for a function that would generate a signed URL
  generateSignedUrl = (url) => {
    console.log("Generating signed URL for:", url);
    // In a real application, this would make an API call to get a secure, temporary URL
    window.open(`https://your-file-server.com/${url}`, "_blank");
  };

  componentDidMount() {
    const vendor_id = localStorage.getItem('temp_vendor_id')?localStorage.getItem('temp_vendor_id'): 23;
    if (vendor_id) {
      this.setState({ vendor_id: vendor_id });
    }
  }

  fetchLocationData = (pin_code) => {
    let endpoint = '/management/po-for-techlocal/?pin=' + pin_code;

    getData(endpoint)
      .then(res => {
        if (res.status === 200) {
          if (res.data.pos && res.data.pos.length > 0) {
            const locationData = res.data.pos[0];
            console.log('Location Data:', locationData);
            this.setState({
              district: locationData.district || "",
              state_name: locationData.state || "",
              country_name: locationData.country || "",
            });
          } else {
            message.error('No location data found for the provided PIN code.');
          }
        }
        else {
          console.log('Loaction fetching error')
        }
      }).catch(error => {
        console.log('Error', error)
      });
  }

  handleCopyDigiPin = () => {
    const { pin_code } = this.state;
    const dynamicLink = `https://dac.indiapost.gov.in/mydigipin/home?pin=${pin_code}`;

    navigator.clipboard.writeText(dynamicLink)
      .then(() => {
        message.success('DigiPin link copied to clipboard!');
      })
      .catch((err) => {
        console.error('Copy failed:', err);
        message.error('Failed to copy DigiPin link.');
      });
  };
  
  handleClose = (id) => {
    console.log("Deleting file with id:", id);
    // This would typically make an API call to delete the file
    // For this example, we'll just filter the state
    this.setState(prevState => ({
        partner_images_info: prevState.partner_images_info.filter(img => img.id !== id)
    }));
    message.success('File Deleted Successfully');
  };

  handleSubmit = (e) => {
    this.setState({ loader: true });
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      console.log("Submitting form with state:", err);
      if (!err) {
        const formData = new FormData();

        const { fileList } = this.state;
        fileList.forEach(file => {
          formData.append('partner_images', file);
        });

        if (this.state.address_proof) {
          formData.append('address_proof', this.state.address_proof);
        }
        formData.append('id', this.state.vendor_id);
        formData.append('location', values.location);
        formData.append('country_name', values.country);
        formData.append('district', values.district);
        formData.append('state_name', values.state);
        formData.append('city_name', values.city);
        formData.append('pin_code', values.pin_code);
        formData.append('digipin', values.digipin || "");

        const endpoint = "/partner/temp-partner-edit/";
        
        createDataUnAuth(endpoint, formData)
        .then((res) => {
          if (res.data["status"] === 200) {
            message.success(res.data["message"]);
            this.props.handleNext();
          } else {
            message.error(res.data["message"]);
          }
          this.setState({ cloader: false, loader: false });
        })
        .catch((error) => {
          console.log(error);
          message.error(error.toString());
          this.setState({ cloader: false, loader: false });
        });

      } else {
        this.setState({ loader: false });
        message.error("Please fill out all required fields.");
      }
    });
  };

  // Placeholder for going back
  handleBack = () => {
    console.log("Going back to the previous step.");
    // this.props.handleBack();
    message.info("Navigated back.");
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: { xs: 24, sm: 8 },
      wrapperCol: { xs: 24, sm: 16 },
    };
    const formItemLayoutfull = {
      labelCol: { xs: 24, sm: 24 },
      wrapperCol: { xs: 24, sm: 24 },
    };
    
    const tailBtnItemLayout = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 24, offset: 0 },
      },
    };

    const props = {
      multiple: true,
      showUploadList: false, // Hide default upload list since we'll show thumbnails
      onRemove: file => {
        this.setState(state => {
          const index = state.fileList.indexOf(file);
          const newFileList = state.fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList,
          };
        });
      },
      beforeUpload: file => {
        this.setState(state => ({
          fileList: [...state.fileList, file],
        }));
        return false;
      },
      fileList: this.state.fileList,
    };

    return (
      <Form onSubmit={this.handleSubmit} style={{ marginTop: '3em' }} className="step-2">
        <Row>
            <Col lg={12} md={12} sm={12} xs={24}>
              <FormItem
                {...formItemLayout}
                label="Location" help={<p style={{ fontSize: 12 }}>(Office No., Building, Street Address)</p>} >
                {getFieldDecorator('location', {
                  initialValue: this.state.location,
                  rules: [{ required: true, message: 'Please input company location!' }],
                })(
                  <Input id="location"
                    suffix={
                      <Tooltip title="Office Number. Building Name, Street etc">
                        <Icon type='info-circle' style={{ color: '#6e10cc ' }} />
                      </Tooltip>
                    }
                  />
                )}
              </FormItem>
            </Col>
            <Col lg={12} md={12} sm={12} xs={24}>
              <FormItem
                {...formItemLayout}
                label="Postal Code">
                {getFieldDecorator('pin_code', {
                  initialValue: this.state.pin_code,
                  rules: [{ required: true, message: 'Please input postal code!' }],
                })(
                  <Input 
                    id="pin_code"
                    type="number"
                    allowClear={true}
                    onChange={(e) => {
                      const value = e.target.value;
                      this.setState({ pin_code: value });
                      
                      if (value.length === 6) {
                        this.fetchLocationData(value);
                      }
                    }}  
                  />
                )}
              </FormItem>
            </Col>
        </Row>
        <Row>
            <Col lg={12} md={12} sm={12} xs={24}>
              <FormItem {...formItemLayout}
                label="City">
                {getFieldDecorator('city', {
                  initialValue: this.state.city_name,
                  rules: [{ required: true, message: 'Please enter your city!', whitespace: true }],
                })(
                    <Input allowClear={true} ></Input>
                )}
              </FormItem>
            </Col>
            <Col lg={12} md={12} sm={12} xs={24}>
              <FormItem
                {...formItemLayout}
                label="District">
                {getFieldDecorator('district', {
                  initialValue: this.state.district,
                })(
                  <Input allowClear={true} ></Input>
                )}
              </FormItem>
            </Col>
            <Col lg={12} md={12} sm={12} xs={24}>
              <FormItem {...formItemLayout}
                label="State">
                {getFieldDecorator('state', {
                  initialValue: this.state.state_name,
                  rules: [{ required: true, message: 'Please select your state!', whitespace: true }],
                })(
                    <Input allowClear={true} ></Input>
                )}
              </FormItem>
            </Col>
            <Col lg={12} md={12} sm={12} xs={24}>
              <FormItem {...formItemLayout}
                label="Country">
                {getFieldDecorator('country', {
                  initialValue: this.state.country_name,
                  rules: [{ required: true, message: 'Please select your country!', whitespace: true }],
                })(
                  <Input />
                )}
              </FormItem>
            </Col>
            <Col lg={12} md={12} sm={12} xs={24}>
              <FormItem
                {...formItemLayout}
                label="Address Proof">
                {getFieldDecorator('address_proof', {
                  rules: [{ required: false, message: 'Please upload adress proof scanned copy' }],
                })(
                  <div>
                    <Input id='myFile3' name='address_proof' type='file' style={{ width: '80%' }} />
                    {this.state.address_file_name ? <a onClick={() => this.generateSignedUrl(this.state.address_file_name)} >See Address Proof Uploaded</a> : ''}
                  </div>
                )}
              </FormItem>
            </Col>
            <Col lg={12} md={12} sm={12} xs={24}>
              <Form.Item
                {...formItemLayout}
                label="DIGIPIN"
                extra={
                  <a onClick={this.handleCopyDigiPin} style={{ fontStyle: 'italic', fontSize: '14px' }}>
                    * Click here to copy the DIGIPIN link
                  </a>
                }
              >
                {getFieldDecorator('digipin', {
                  initialValue: this.state.digipin,
                  rules: [{ required: false, message: 'Please enter the DIGIPIN' }],
                })(<Input />)}
              </Form.Item>
            </Col>            
        </Row>

        <Row>
          <Col lg={24} md={24} sm={24} xs={24}>
            <FormItem label="Please upload a few images of the shop?" {...formItemLayoutfull}>
              {getFieldDecorator('upload', {
                  rules: [{ required: false, message: 'Please upload a few images of the shop?' }],
              })(
                <Upload {...props}>
                  <Button>
                    <Icon type="upload" /> Select File
                  </Button>
                </Upload>
              )}
            </FormItem>
            {/* Show thumbnails of uploaded files */}
            {this.state.fileList.length > 0 && (
              <div style={{ marginTop: 0 }}>
                <p style={{ fontWeight: 'normal', marginBottom: '8px' }}>Uploaded Images:</p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                  {this.state.fileList.map((file, index) => (
                    <div key={index} style={{ position: 'relative', display: 'inline-block' }}>
                      <img
                        src={URL.createObjectURL(file)}
                        alt={file.name}
                        style={{
                          width: '80px',
                          height: '80px',
                          objectFit: 'cover',
                          borderRadius: '4px',
                          border: '1px solid #d9d9d9'
                        }}
                      />
                      <Popconfirm
                        title="Sure to delete?"
                        onConfirm={() => {
                          this.setState(state => {
                            const newFileList = state.fileList.filter((_, i) => i !== index);
                            return { fileList: newFileList };
                          });
                        }}
                      >
                        <Icon
                          type="delete"
                          style={{
                            position: 'absolute',
                            top: '-8px',
                            right: '-8px',
                            background: 'red',
                            color: 'white',
                            borderRadius: '50%',
                            padding: '2px',
                            cursor: 'pointer',
                            fontSize: '12px'
                          }}
                        />
                      </Popconfirm>
                      <div style={{ 
                        fontSize: '10px', 
                        textAlign: 'center', 
                        marginTop: '4px',
                        maxWidth: '80px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                      }}>
                        {file.name}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {/* Show existing partner images */}
            {this.state.partner_images_info.length > 0 && (
              <FormItem {...formItemLayout}>
                <p style={{ fontWeight: 'bold', marginBottom: '8px' }}>Existing Images:</p>
                {this.state.partner_images_info.map((x) => (
                  <div key={x.id} style={{ marginBottom: '8px' }}>
                    <Popconfirm title="Sure to delete?" onConfirm={() => this.handleClose(x.id)} >
                      <Tag>{x.image_key.substring(x.image_key.lastIndexOf('/') + 1)} </Tag>
                      <a style={{ color: "red", marginLeft: '8px' }}>
                        <Icon type="delete" />
                      </a>
                    </Popconfirm>
                  </div>
                ))}
              </FormItem>
            )}
          </Col>
        </Row>

        <FormItem style={{ marginTop: '3em' }} {...tailBtnItemLayout} >
            <Button style={{ float: 'left' }} type="primary" onClick={this.props.handleBack} htmlType="button" icon="arrow-left">Back</Button>
            <Button style={{ float: 'right' }} type="primary" htmlType="submit" icon="arrow-right" loading={this.state.loader} >Next</Button>
        </FormItem>

      </Form>
    );
  }
}

const WrappedCombinedForm = Form.create()(CombinedForm);
export default WrappedCombinedForm;